import { combineReducers } from 'redux';
import legacyUser from 'vn-legacy-user';
import application from './ducks/ApplicationDucks';
import documents from './ducks/DocumentsDucks';
import documentTypes from './ducks/DocumentTypesDucks';
import guests from './ducks/GuestsDucks';
import invites from './ducks/InvitesDucks';

const rootReducer = combineReducers({
  application,
  documents,
  documentTypes,
  legacyUser,
  guests,
  invites,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js